import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RestaurantComponent } from './restaurant.component';

const route: Routes = [
  {
    path: '',
    component: RestaurantComponent,
    data: { page: 'store' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(route)],
  exports: [RouterModule],
})
export class RestaurantRoutingModule {}
